import React from 'react';

const HeaderTitle = (props) => 
{
return(
    <div className={props.className}>
        {props.children}
    </div>
)
}

export default HeaderTitle;